import { render, staticRenderFns } from "./custom-footer-datatable.vue?vue&type=template&id=c013e8ec&scoped=true"
import script from "./custom-footer-datatable.vue?vue&type=script&lang=js"
export * from "./custom-footer-datatable.vue?vue&type=script&lang=js"
import style0 from "./custom-footer-datatable.vue?vue&type=style&index=0&id=c013e8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c013e8ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSelect,VSpacer})
